<template>
    <div :class="[
        'dropdown',
        { 'is-error': isError && this.validatedValue !== 0 }
    ]">
        <select 
            aria-label="Wybierz" 
            @change="onChange"
        >
            <option 
                value="null"
                v-text="placeholder"
            />
            <option 
                v-for="(item, i) in items" 
                :key="i" 
                :value="item.value"
                v-text="item.label" 
            />
        </select>
        <i class="icon-arrow-down" />
    </div>
</template>

<script>
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ValidateMixin
    ],

    props: {
        items: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Wybierz powód'
        }
    },

    data() {
        return {
            currentValue: null
        }
    },

    computed: {
        validatedValue() {
            return this.currentValue
        }
    },

    mounted() {
        this.$emit('change', this.items[0])
    },

    methods: {
        onChange (e) {
            let item = this.items.filter(v => parseInt(v.value) === parseInt(e.target.value))

            this.$emit('change', item[0], e)

            this.isError = false

            this.currentValue = item[0] ? item[0].value : null
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired()
            ]
        }
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/mixins/_mixins.scss';
@import '@/assets/scss/variables/_variables.scss';

.dropdown {
    position: relative;

    &.is-error {
        > select {
            border-color: $color-error;
        }
    }

    &:after {
        content: '';
        @include size(0);
        position: absolute;
        pointer-events: none;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid $color-default;
        right: 12px;
        top: 18px;
    }
    
    > select {
        @include transition(border-color .1s ease-in-out);
        display: inline-block; 
        vertical-align: middle; 
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
        border: 1px solid $color-border;
        outline: 0;
        text-indent: 1px;
        padding: 10px 25px 10px;
        width: 100%;
        min-width: 323px;
        font-size: 1.8rem;
        
        &:hover {
            border-color: $color-primary;
        }

        &::-ms-expand {
            display: none;
        }
    }
}
</style>